import { Controller } from "@hotwired/stimulus"
import $ from "jquery"


export default class extends Controller {

    connect() {

          $.ajax({
            type: "get",
             url: 'https://api.actualoptic.kz:8443/cabinet/doctor/'+ usertoken,
             contentType: "application/json",
             acync: false,
             success: function(data){
              if (data === null){
                  $('#doctor').hide()
              } else {
                  $('#doctorPhoto').html('<img class="doctor__photo__img" src="https://actualoptic.kz/image/'+ data.image +'" alt="' + data.doctor_name +'" width="105" height="130">');
                  $('#doctorInfoLink').attr('href', 'https://actualoptic.kz/index.php?route=extension/actualoptic/branches/staff&staff_id='+ data.id);
                  $('#doctorName').text(data.doctor_name);
                  $('#doctorScheduleLink').attr('href','doctor-schedule.html?' +usertoken)
              }

            },
             error(error){
                 console.debug(error);
                 //window.location.replace("404.html");
            }

         });
    }
}